import { Layout, Menu } from 'element-react';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory} from "react-router-dom";
import userStore from '../store/user';
import menuStore from '../store/menu-selected';
import { label } from 'aws-amplify';

const BuyerToolsLeftMenu = () =>{
    const {t} = useTranslation();
    let history = useHistory();
    const { user } = userStore();  
    const {menuIndex, setMenuIndex} = menuStore();

    // Estado para controlar si el menú está fijo
    const [isSticky, setIsSticky] = useState(false);

    // Efecto para detectar la posición del scroll
    useEffect(() => {
        const handleScroll = () => {
            // Ajuste de la altura de tu header
            const scrollThreshold = 130; 
            if (window.scrollY > scrollThreshold) {
                setIsSticky(true);
            } else {
                setIsSticky(false);
            }
        };
        window.addEventListener('scroll', handleScroll);
        // se limpia el listener al desmontar el componente
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const _menuItems = [
            {
                label: "Buyer Dashboard",
                linkTo: "/tools/dashboard",
                icon: ""
            },
            {
                label: "Buying Orders",
                linkTo: "/tools/my-orders",
                icon: ""
            },
            {
                label: "Create RFQ",
                linkTo: "/tools/rfq",
                icon: ""
            },
            {
                label: "My RFQs",
                linkTo: "/tools/active-rfq",
                icon: ""
            },
            {
                label: "Favorites",
                linkTo: "/tools/favorites",
                icon: ""
            }
            
    ]
        
    function renderMenu () {
        console.log("rendering menu")
        console.log('menuIndex :: ' + menuIndex);
        let menuItems = _menuItems;
        return createMenuItems(menuItems)
    }

    function createMenuItems(items) {
        return items.map((item, index) => {
            if(!item.submenu) {
                 let clazzName = item.linkTo === menuIndex ? "cursor menu-selected" : "cursor"
                return (
                    <div
                        onClick={() => {
                            setMenuIndex(item.linkTo);
                            history.push(item.linkTo);
                        }}
                    >
                        <Menu.Item className="left-menu-item" index={item.linkTo} key={index}>
                        
                            <label className={clazzName} >
                                {((item.label))}
                            </label>
                        </Menu.Item>
                    </div>
                )
            } else {
                return (
                    <Menu.SubMenu index="2" title={<label className="cursor">{t((item.label))}</label>} key={index}>
                        { createMenuItems(item.submenu) }
                    </Menu.SubMenu>
                )
            }
        })
    }
    
    return(
        <Layout.Row className={`tac main-left-menu ${isSticky ? 'menu-is-sticky' : ''}`}>
            <Layout.Col span={24}>
                <div className="sidenav">
                    <Menu defaultActive="/my-account" className="el-menu-vertical-demo">
                        <Menu.Item index="" className="left-menu-title">
                            {'BUYER TOOLS'}
                        </Menu.Item>
                        {renderMenu()}
                    </Menu>
                </div>
            </Layout.Col>
        </Layout.Row>
    )
}

export default BuyerToolsLeftMenu;